export const POWER_OPTIONS = [
  "Shutdown",
  "Restart",
  "Logout",
  "Hibernate",
  "Sleep",
  "Lock",
];

const DIAGNOSTIC_TOOLS = [
  { name: "Task Manager", operatingSystems: ["windows", "linux","mac"] },
  { name: "Command Prompt", operatingSystems: ["windows", "linux","mac"] },
  { name: "Services", operatingSystems: ["windows", "mac", "linux"] },
  { name: "Event Viewer", operatingSystems: ["windows","mac"] },
  { name: "Registry", operatingSystems: ["windows","mac"] },
  { name: "File Explorer", operatingSystems: ["windows","linux","mac"] },
];

export const normalizeDeviceOs = (os) => {
  const normalizedOs = `${os || ""}`.toLowerCase();
  if (normalizedOs.includes("mac")) return "mac";
  if (normalizedOs.includes("linux")) return "linux";
  if (normalizedOs.includes("windows")) return "windows";
  return null;
};

export const getDiagnosticToolOptions = (os) => {
  const platform = normalizeDeviceOs(os);
  return platform
    ? DIAGNOSTIC_TOOLS.filter((tool) =>
        tool.operatingSystems.includes(platform),
      ).map((tool) => tool.name)
    : [];
};
